import { Design, Mask, Point, SizePx } from '@/types';
import { createMaskedDesign } from '@/utils/http/createMaskedDesign';
import { getParams } from '@/utils/params';

export function applyMask(
  { id: designId, size: { width: designWidth, height: designHeight } }: Design,
  { id: maskId }: Mask,
  { x: offsetX, y: offsetY }: Point,
  { width: maskWidth, height: maskHeight }: SizePx
) {
  const maskPayload = {
    transformX: offsetX * (designWidth - maskWidth),
    transformY: offsetY * (designHeight - maskHeight),
    designId: designId,
    targetShopId: getParams().contextId,
    maskWidth: maskWidth,
    maskHeight: maskHeight,
  };

  return createMaskedDesign(maskId, maskPayload);
}
